<template>
  <div>
    <div
      v-for="(cycle, cycleIndex) in sortedInspirations"
      :key="cycleIndex"
    >
      <div class="grid gap-6 grid-cols-2 md:grid-cols-4 lg:mb-6 max-w-1440 mx-auto px-4 md:px-8 lg:px-16 py-8 w-full">
        <product-card
          v-for="item in cycle"
          :key="item.id"
          :model="item"
          class="mb-8"
          width="300"
          height="300"
          @item-click="onItemClick"
        />
      </div>
      <template
        v-if="cycleIndex < sortedInspirations.length - 1 || items.length <= 8"
      >
        <search-inspiration-block
          :inspirations="inspirations[cycleIndex]"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import SearchInspirationBlock from '@/components/search/SearchInspirationBlock.vue'
import ProductCard from '@/components/products/ProductCard.vue'

export default {
  components: {
    ProductCard,
    SearchInspirationBlock
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    inspirations: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props) {
    const sortedInspirations = computed(() => {
      const cycles = []
      const itemsPerCycle = window.outerWidth <= 992 ? 4 : 8
      const numberOfCycles = Math.ceil(props.items.length / itemsPerCycle)

      for (let i = 0; i < numberOfCycles; i += 1) {
        const startIndex = i * itemsPerCycle
        const endIndex = startIndex + itemsPerCycle
        cycles.push(props.items.slice(startIndex, endIndex))
      }

      return cycles
    })
    const onItemClick = (hitId, position) => {
      this.$emit('item-click', { hitId, position })
    }

    return {
      sortedInspirations,
      onItemClick
    }
  }
}
</script>
